import { FunctionComponent } from "react";

interface GoogleAuthButtonProps {
  onClick: () => void;
  label: string;
  ariaLabel: string;
  disabled?: boolean;
}

const GoogleAuthButton: FunctionComponent<GoogleAuthButtonProps> = ({
  onClick,
  label,
  ariaLabel,
  disabled = false,
}) => {
  // [2026-02-07] style-extraction: moved inline styles to _auth.scss
  return (
    <button
      type="button"
      className="bg-transparent google-row google-auth-button d-flex align-items-center justify-content-start gap-2"
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="google-icon-container">
        <img src="/google.svg" alt="Google" className="google-icon" />
      </div>
      <span className="u-P1-18 text-color-black">{label}</span>
    </button>
  );
};

export default GoogleAuthButton;
